export default function getAviso (token, returnurl) {

  return fetch(`${process.env.REACT_APP_API_AVISOS_URL}/avisoInterpuestoAtekaIdAplicacion/HTN.SistemaRepresentaciones.Web/?returnurl=${returnurl}`, {
  //'Referer': 'unsafe-url',    
  
    method: 'GET',
    headers: {
      "Content-Type": "application/json",              
      'HTTP_HEADER_NOMBREAPLICACION': 'HTN.SistemaRepresentaciones.Web',      
      'Authorization': token      
    }    
  }).then((response) => {
    return new Promise((resolve) => response.json()
      .then((json) => resolve({
        status: response.status,
        ok: response.ok,
        json,
      })));
  }).then(({ status, json, ok }) => {
    const mjeError = ok? '' : json.status + ': ' +  json.title;   
  
    return { ok: ok, mjeError: mjeError, respuesta: json }        
  })
      
}    
  